import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';
import { Configuracion } from '../models/Util';

@Injectable({
  providedIn: 'root'
})
export class PruebasService {
  private readonly PARAM_ID = 614;
  private readonly URL_CF = environment.apiUrl + 'u/cf/';

  private urlSubject = new BehaviorSubject<string | undefined>(undefined);
  public pruebasUrl$ = this.urlSubject.asObservable();

  constructor(private http: HttpClient) {
    this.load();
  }

  load(): void {
    this.http.get<Configuracion>(this.URL_CF + this.PARAM_ID).subscribe({
      next: (conf) => this.urlSubject.next(conf?.texto),
      error: (_) => this.urlSubject.next(undefined)
    });
  }

  refresh(): void {
    this.load();
  }

}
